"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTimeout = useTimeout;

var _react = require("react");

// export function useTimeout(callback: () => void, delay: number) {
//   const savedCallback = useRef<() => void>();
//   useEffect(() => {
//     savedCallback.current = callback;
//   }, [callback]);
//   useEffect(() => {
//     let id: number;
//     if (savedCallback.current) {
//       id = window.setTimeout(savedCallback.current, delay);
//     } else {
//       id = window.setTimeout(() => {}, delay);
//     }
//     return () => clearTimeout(id);
//   }, [delay]);
// }
function useTimeout(callback, delay) {
  var savedCallback = (0, _react.useRef)(function () {});
  (0, _react.useEffect)(function () {
    savedCallback.current = callback;
  }, [callback]);
  (0, _react.useEffect)(function () {
    function tick() {
      savedCallback.current();
    }

    if (delay != null) {
      var id = setTimeout(tick, delay);
      return function () {
        return clearTimeout(id);
      };
    }
  }, [delay]);
}